import { useState, useRef, useEffect, useContext } from 'react';
import classes from './success.module.scss';
import successImg from '../../../../assets/img/loader-white background-150x150.gif';
import LoginContext from '../../../../store/login-context';

declare var _siteSettings: any;
declare var _target: any;
declare function Translate(key: string): string;
declare var _serverUrl: string;

const Success = () => {
  const formRef:any = useRef(undefined);
  const ctx = useContext(LoginContext);

useEffect(() => {  
  if(!ctx.devMode){   
    setTimeout(() => {
      formRef.current.submit();
    }, parseInt(_siteSettings.successMessageShowTimeout, 10) + 700);
  }
  else{
    setTimeout(() => {      
      window.open('https://www.gov.il/',"_self");
    }, 3000); 
  }
},[]);

  return (
    <div className={classes.success_wrapper}>
      <form
        action={_serverUrl}
        method='POST'
        style={{ display: 'none' }}
        ref={formRef}
      >
        <input type='hidden' name='option' value='credential' />
        <input type='hidden' name='target' value={_target} />
        <input id="op" type="hidden" name="op" value="done" />  
      </form>
      <div
        className={classes.success_container}
        role='alert'        
      >
        <div className={classes.success_logo}>
          <img className={classes.success_bird} src={successImg}  />
        </div>
        <div className={classes.success_title}>
          {Translate('N_General_conection_success')}
        </div>
        <div className={classes.succes_text}>
          {Translate('N_General_conection_success_01')}          
        </div>
        <div className={classes.succes_text}>
          {Translate('N_General_conection_success_02')}
        </div>
      </div>
    </div>
  );
};
export default Success;

